/***
 * 创建人：李珊
 * 时间：2020-12-25
 * 描述：标签管理-添加及编辑标签
 * 更新说明:
 */
import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
@Component({
    selector: 'app-label-add',
    templateUrl: './label-add.component.html',
    styleUrls: ['./label-add.component.css']
})
export class LabelAddComponent implements OnInit {

    @ViewChild('modal') modal: SwModalframeComponent;    //弹出层组件
    @Input() param: any;
    @Output() callback = new EventEmitter(); //抛出事件
    //数据绑定对象
    tagModel: any = {};
    //标头提示信息
    headerLoGo: string;
    // 抓取类型选项
    tagCategoryOptions = [
        {
            id: 1,
            text: '标签'
        },
        {
            id: 2,
            text: '标签分类'
        }
    ];
    // 父级分类树数据
    tagTreeDatas: any = [];
    //提交按钮是否禁用
    clickEnable = true;
    constructor(
        private box: SwMassageBoxService,  //消息提示框
        private kmsService: KmsService,   //请求服务
    ) {

    }

    ngOnInit() {
        this.clickLoca(this.param["upOrAdd"], this.param["selectedData"], this.param["parentId"]);
    }

    //标签点击新增 或者 修改
    clickLoca(upOrAdd: string, selectedData: any, parentId:string) {
        // 修改操作
        if (upOrAdd == "Edit") {
            //修改提示头
            this.headerLoGo = "编辑标签信息"
            // 查询标签信息
            this.kmsService.queryTagById(selectedData.tagId).subscribe(
                data => {
                    if (data["code"] == '200') {
                        this.tagModel = data["data"];
                        this.tagModel.parentId = this.tagModel.parentId ? this.tagModel.parentId : '0';
                        // 查询父级分类树数据
                        this.getTagTreeCategorys();
                    }
                }
            )
        } else {
            //新增标签数据 默认绑定标签基础数据
            this.headerLoGo = "新增标签信息";
            this.tagModel.tagId = '';
            this.tagModel.tagName = '';
            this.tagModel.tagCategory = 1;
            this.tagModel.parentId = parentId;
            // 查询父级分类树数据
            this.getTagTreeCategorys();
        }
    }

    // 查询父级分类树数据
    getTagTreeCategorys(){
        this.tagTreeDatas = [];
        this.kmsService.queryTagTree({}).subscribe(result => {
            if (result.code == 200) {
                if (result.data.length > 0) {
                    let datas = result.data
                    this.tagTreeDatas = datas;
                    this.tagTreeDatas.forEach(item => {
                        item['id'] = item['tagId'];
                        item['parentId'] = item['parentId'] ? item['parentId'] : '0';
                        item['pid'] = item['parentId'];
                        item['text'] = item['tagName'];
                    });
                }
                const rootNode = {
                    'id': '0',
                    'pid': null,
                    'text': '标签分类',
                    'parentId': null
                };
                this.tagTreeDatas.push(rootNode);
                this.parentNodeChange();
            }
        })
    }

    // 选择父级分类结点时触发
    parentNodeChange(event?) {
        if(this.tagModel.parentId){
            let level = this.getLevel(this.tagModel.parentId, 1);
            this.tagModel.tagLevel = level;
        }else{
            this.tagModel.tagLevel = 1;
        }
    }

    // 根据父结点id获取当前关系层级及所属概念组的主键id
    getLevel(id,level){
        let data = this.tagTreeDatas.filter(item => item.id == id)[0];
        if(!data || !data.pid){
            return level;
        }
        else if(data.pid == '0'){
            return ++level;
        }else{
            return this.getLevel(data.pid,++level);
        }
    }

    // 关系表单，清除父级分类结点时触发
    clearParentNode(event) {
        this.tagModel.tagLevel = 1;
    }

    //提交 保存 或者修改操作
    onSubmit({ value, valid }, event: Event) {
        if (valid) {
            this.clickEnable = false;
            value.parentId = value.parentId == '0' ? '' : value.parentId;
            // 判断是否选择父级分类
            if(value.parentId){
                this.saveTagInfo(value);
            }
            // 若未选择父级分类
            else{
                // 若当前是对标签值进行操作
                if(value.tagCategory == 1){
                    // 判断当前是否已创建了“其他”分类
                    let items = this.tagTreeDatas.filter(item => (item.text == '其他' && item.tagLevel == 1));
                    // 若已创建，将当前标签的父级分类设为“其他”，并保存标签信息
                    if(items.length > 0){
                        value.parentId = items[0].tagId;
                        value.tagLevel = 2;
                        this.saveTagInfo(value);
                    }else{
                        // 先创建其他分类
                        let params = {
                            tagName: '其他',
                            tagLevel: 1,
                            tagCategory: 2,
                            parentId: ''
                        }
                        this.kmsService.saveTag(params).subscribe(
                            data => {
                                if (data["code"] == '200') {
                                    // 将当前标签的父级分类设为“其他”，并保存标签信息
                                    value.parentId = data.data.tagId;
                                    value.tagLevel = 2;
                                    this.saveTagInfo(value);
                                }else if(data["code"] == '670'){
                                    value.parentId = '';
                                    value.tagLevel = 1;
                                    this.saveTagInfo(value);
                                }else{
                                    this.clickEnable = true;
                                    this.box.waring(data.msg);
                                }
                            }
                        )
                    }
                }
                // 若当前是对标签分类进行操作
                else{
                    this.saveTagInfo(value);
                }
            }
        } else {
            this.box.waringError('请输入完整且正确的信息')
        }
    }

    // 保存标签信息
    saveTagInfo(value){
        this.kmsService.saveTag(value).subscribe(
            data => {
                this.clickEnable = true;
                if (data["code"] == '200') {
                    this.tagModel = data["data"];
                    //抛出事件 提示 关闭模态框
                    this.modal.toggle();
                    this.callback.emit(true);
                    this.box.success('保存成功');
                } else {
                    this.box.waring(data.msg);
                }
            }
        )
    }
}
